import { render, staticRenderFns } from "./GsMessageLog.vue?vue&type=template&id=3a3b6bec&"
import script from "./GsMessageLog.vue?vue&type=script&lang=js&"
export * from "./GsMessageLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports